import { useEffect } from "react";

const HEX = /^#?([0-9a-f]{6}|[0-9a-f]{3})$/i;

export function isHexColor(v) {
  return HEX.test((v || "").trim());
}

export function normaliseHex(v) {
  const m = HEX.exec((v || "").trim());
  if (!m) return "";
  let h = m[1];
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  return `#${h.toUpperCase()}`;
}

export function hexToHsl(hex) {
  const h6 = normaliseHex(hex).slice(1);
  if (!h6) return null;
  const r = parseInt(h6.slice(0, 2), 16) / 255, g = parseInt(h6.slice(2, 4), 16) / 255, b = parseInt(h6.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  let h = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
    else if (max === g) h = ((b - r) / d + 2) / 6;
    else h = ((r - g) / d + 4) / 6;
  }
  return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
}

export function isDarkColor(hex) {
  const h6 = normaliseHex(hex).slice(1);
  if (!h6) return true;
  const r = parseInt(h6.slice(0, 2), 16), g = parseInt(h6.slice(2, 4), 16), b = parseInt(h6.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.6;
}

/* Tailwind tokens (--primary etc.) are HSL triplets; set them on `el` so bg-primary / text-primary pick up the brand. */
export function brandVars(hex) {
  const hsl = hexToHsl(hex);
  if (!hsl) return {};
  const v = `${hsl.h} ${hsl.s}% ${hsl.l}%`;
  return { "--primary": v, "--ring": v, "--primary-foreground": isDarkColor(hex) ? "210 40% 98%" : "222 47% 11%" };
}

export function applyBrandColor(hex, el = document.documentElement) {
  const vars = brandVars(hex);
  const keys = Object.keys(vars);
  if (!keys.length) return () => {};
  const prev = keys.map((k) => [k, el.style.getPropertyValue(k)]);
  keys.forEach((k) => el.style.setProperty(k, vars[k]));
  return () => prev.forEach(([k, v]) => (v ? el.style.setProperty(k, v) : el.style.removeProperty(k)));
}

export function useBrandColor(hex) {
  useEffect(() => (hex ? applyBrandColor(hex) : undefined), [hex]);
}
